import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative z-20" }
const _hoisted_2 = { class: "flex flex-col items-center gap-12 pt-20" }
const _hoisted_3 = { class: "inline-flex text-[1.75rem] font-medium uppercase leading-9 dark:text-white" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "relative inline-flex w-12 justify-center text-blue-500"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "absolute inset-0 w-full h-full flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_vue = _resolveComponent("svg-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Carousel"], {
      ref: "slider",
      "items-to-show": 1,
      "wrap-around": true
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, (slide, index) => {
          return (_openBlock(), _createBlock($setup["Slide"], { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h3", _hoisted_3, [
                  _createElementVNode("span", {
                    innerHTML: slide.title_before
                  }, null, 8 /* PROPS */, _hoisted_4),
                  (slide.days)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_svg_vue, {
                          icon: "round-scribble",
                          class: "absolute left-0 top-1/2 h-auto w-full -translate-y-1/2 stroke-blue-500"
                        }),
                        _createTextVNode(" " + _toDisplayString(slide.days.toString().replace(".", ",")), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(" " + _toDisplayString(slide.title_after && slide.title_after !== "" ? slide.title_after : ""), 1 /* TEXT */)
                ]),
                _createElementVNode("img", {
                  class: "h-[25rem] object-contain object-center sm:h-[27.4rem] w-auto",
                  src: slide.image,
                  alt: "slide.image"
                }, null, 8 /* PROPS */, _hoisted_6)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "text-[#9164F0] hover:text-blue-500",
        onClick: $setup.prev
      }, [
        _createVNode(_component_svg_vue, {
          icon: "carousel-left",
          class: "w-12 sm:w-[3.8125rem] transition-colors h-auto"
        })
      ]),
      _createElementVNode("button", {
        class: "text-[#9164F0] hover:text-blue-500",
        onClick: $setup.next
      }, [
        _createVNode(_component_svg_vue, {
          icon: "carousel-right",
          class: "w-12 sm:w-[3.8125rem] transition-colors h-auto"
        })
      ])
    ])
  ]))
}